import { ctaDesc, ctaTitle } from "@/lib/seo";
// /en/translate/embassy-legalization — EN mirror
import QuotableStatsStrip from "@/components/QuotableStatsStrip";
import { createFileRoute } from "@tanstack/react-router";
import { CertTypeHub } from "@/components/translate/CertTypeHub";
import { getCertType } from "@/data/translation-certtypes";
import { speakableSchema, serviceWithReviewsSchema, howToSchema } from "@/lib/aeo";
import { consolidateGraph } from "@/lib/schema-graph";
import { claimReviewSchema, softwareApplicationSchema, entitySameAsSchema, COMMON_CLAIM_REBUTTALS_EN } from "@/lib/trust-schema";

const SITE = "https://nyclanguageinstitute.com";
const cert = getCertType("embassy-legalization")!;

export const Route = createFileRoute("/en/translate/embassy-legalization")({
  head: () => {
    const url = `${SITE}/en/translate/embassy-legalization`;
    const title = "Embassy & Document Legalization Thailand | NYC";
    const desc = "Embassy + MFA legalization for Thai-issued documents — accepted worldwide. Translation. Free consultation — message us and get a same-day answer.";
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/embassy-legalization", "en") }, { name: "description", content: ctaDesc(desc, "/en/translate/embassy-legalization", "en")},
        { name: "keywords", content: cert.keywords.join(", ") },
        { property: "og:title", content: ctaTitle(title, "/en/translate/embassy-legalization", "en")}, { property: "og:description", content: ctaDesc(desc, "/en/translate/embassy-legalization", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${SITE}/translate/embassy-legalization` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/translate/embassy-legalization` },
      ],
      scripts: [
        speakableSchema(),
        howToSchema({
          name: "How NYC manages embassy legalization end-to-end",
          description: cert.taglineEn,
          totalTime: "PT10D", estimatedCost: { currency: "THB", value: String(cert.priceFromThb) },
          steps: cert.stepsEn.map((s) => ({ name: s.name, text: s.text })),
        }),
        consolidateGraph([
          serviceWithReviewsSchema({ path: "/en/translate/embassy-legalization", serviceType: "Embassy Legalization", name: title, description: desc, priceFromThb: cert.priceFromThb }),
          {
            type: "application/ld+json" as const,
            children: JSON.stringify({
              "@context": "https://schema.org", "@type": "FAQPage", "@id": `${url}#faq`, inLanguage: "en",
              mainEntity: cert.faqsEn.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
            }),
          },
        ]),
        entitySameAsSchema(),
        softwareApplicationSchema({ url: `${SITE}/api/public/mcp`, name: "NYC Language Institute — MCP Server", description: "AI agent endpoint exposing embassy legalization tooling." }),
        claimReviewSchema(COMMON_CLAIM_REBUTTALS_EN(url)),
      ],
    };
  },
  component: () => <CertTypeHub cert={cert} locale="en" />,
});
